export const CHANGE_STYES = "CHANGE_STYES";


export const changeStyleAction = data => ({
	type: CHANGE_STYES,
	payload: data
});